import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { verifyToken, setToken } from "@/api";

export default function VerifyPage({ onAuthed }) {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; // guard against StrictMode double-run (token is single-use)
    ran.current = true;
    const token = params.get("token");
    if (!token) {
      setError("This sign-in link is missing its token.");
      return;
    }
    (async () => {
      try {
        const res = await verifyToken(token);
        setToken(res.access_token);
        onAuthed(res.user);
        navigate("/", { replace: true });
      } catch (err) {
        setError(err?.response?.data?.detail || "This sign-in link is invalid or has expired.");
      }
    })();
  }, [params, navigate, onAuthed]);

  if (error) {
    return (
      <div className="auth-screen">
        <div className="auth-card" data-testid="verify-error-card">
          <div className="auth-head">
            <div className="auth-eyebrow"><span className="eyebrow-dot" /> Lonesome Cactus Studio</div>
            <h1 className="auth-title">Sign-in <em>link issue</em></h1>
          </div>
          <div className="auth-body">
            <div className="auth-msg err" data-testid="verify-error-message">{error}</div>
            <button className="auth-btn" onClick={() => navigate("/", { replace: true })} data-testid="verify-back-button">
              Request a new link →
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-loading" data-testid="verify-loading">
      <div className="gen-dots"><span /><span /><span /></div>
      Signing you in…
    </div>
  );
}
